<ng-container>
    <div *ngIf="!meshLoaded" class ="skeleton loading skeletoncard"></div>
    <ispm-anatomy3d-viewer *ngIf="meshData && modelViewerData; else no_display"
                           [prostateMeshData]="meshData"
                           [summryTable]="summaryTableArry"
                           [width]="width"
                           (updateReport)="updateReport($event)"
    >
    </ispm-anatomy3d-viewer>
</ng-container>
<ng-template #no_display>
    <section *ngIf="meshLoaded" class="empty-message-display"> no biopsy information available </section>
</ng-template>
